<div class="list-editor">
  @for (item of listValue; track item; let i = $index) {
    <div class="ui large label">
      {{item}}
      <a (click)="onDeleteValue(i)"><i class="delete icon"></i></a>
    </div>
  }
  <input type="text" placeholder="type space or click outside to add" style="width: 18em !important;" (blur)="onBlur($event)" (input)="onNewValue($event)">
  <span class="hint-text">{{hint}}</span>
</div>
